/**
 * 如果Component不会被其他地方复用，没有必要增加文件
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {WKInfiniteScroll} from '../components/wk';
import {Page} from '../components';


import '../css/page/CouponViewPage.css';


class CouponReceiver extends Component {
    render() {
        const {item} = this.props
        return <div className="receiver-item">
            <div className="left">
                <img src={item.account.small_avatar_url} alt="" />
            </div>
            <div className="right">
                <div className="nickname">
                    {item.account.nickname}
                </div>
                <div className="time">
                    {item.create_time}
                </div>
                <div className="status">
                    {item.status === 'active' && <span>未使用</span>}
                    {item.status === 'used' && <span className="used">已使用</span>}
                    {item.status === 'expired' && <span className="used">已过期</span>}
                </div>
            </div>
        </div>
    }
}


class CouponViewPage extends Component {
    constructor() {
        super()
        this.state = {
            items: [],
            initialized: false,
            offset: 0,
            hasMore: true,
            loading: false,
        }
        this.loading = false
    }

    componentDidMount() {
        this.load()
    }

    load() {
        const {liveroom_id, coupon_id} = this.props.params
        const params = {
            offset: this.state.offset
        }
        this.setState({ loading: true })
        this.page.showLoading()
        axios.get(`/api/liveroom/${liveroom_id}/coupon/${coupon_id}/receiver/list`, {params}).then((res) => {
            this.page.hideLoading()
            if (res.data.code === 0) {
                const {data} = res.data
                this.setState({
                    initialized: true,
                    offset: data.next_offset,
                    hasMore: data.has_more,
                    items: [...this.state.items, ...data.receivers],
                    loading: false,
                })
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg
                    }
                })
            }
        }).catch((error) => {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '读取错误：' + error
                }
            })
        })
    }

    render() {
        const {items} = this.state
        return (
            <Page parent={this}>
                <div ref="list" className="receiver-list">
                    {
                    items&&items.length>0?items.map((item) => (
                        <CouponReceiver key={item.id} item={item} />
                    )):(
                      <div className="blank-picture">
                        <div>
                          <img src="https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-wnr.png" alt=""/>
                          <div className="blank-text">空空如也</div>
                        </div>
                      </div>
                    )
                    }
                </div>
                <WKInfiniteScroll 
                    onTouchBottom={() => this.load()} // 到达底部执行的方法
                    isStop={this.state.loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                    isKill={!this.state.hasMore} // 不再监听滚动，一般是传has_more 
                    isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
                />
            </Page>
        )
    }
}


export default connect((state) => ({
}))(CouponViewPage)



// WEBPACK FOOTER //
// ./src/pages/CouponViewPage.js